module.exports = __webpack_public_path__ + "static/cssday-2026-27-8725c36ce0e0efb778fbc137c3026dc8.jpg";